import { useResponsiveConstants } from './responsive/useResponsiveConstants';
import { useDevices } from './useDevices';
import { useIsNeedlPublishedFeed } from './useIsNeedlPublishedFeed';

export const useShowNoDataTabs = () => {
  const { mobile } = useResponsiveConstants();
  const { native } = useDevices();
  const { isNeedlPublishedFeed } = useIsNeedlPublishedFeed();

  return !(mobile || native || isNeedlPublishedFeed);
};
